import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter } from 'react-router-dom';
import { MyProvider } from './User/Context/MyContext';
import { colors } from './Utils/colors';

// CSS Variables create pannudhu
Object.keys(colors).forEach((key) => {
  document.documentElement.style.setProperty(
    `--${key}`,
    colors[key]
  );
});
document.documentElement.style.setProperty(
  "--header-height",
  colors.headerHeight?.trim() || "70px"
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <MyProvider>
      <App />
    </MyProvider>
  </BrowserRouter>
);

reportWebVitals();
